export default class DOMUtils {
  static getElemTop(elem) {
    const $elem = elem instanceof jQuery ? elem : $(elem);

    if ($elem.length > 0) {
      return $elem.offset().top;
    }

    return 0;
  }

  /**
   * Gets the combined content height of visible top level children
   * that are in the standard page flow.
   */
  static getContentHeight(elem) {
    const $elem = elem instanceof jQuery ? elem : $(elem);

    let contentHeight = 0;
    $elem.children("*").not(":hidden").each((index, el) => {
      const $this = $(el);
      if ($this.css("position") === "static" || $this.css("position") === "sticky") {
        contentHeight += $this.outerHeight(true);
      }
    });

    return contentHeight;
  }

  /**
   * Observes elem and calls the given callback function every time elem's height changes.
   */
  static onContentHeightChange(elem, callback) {
    const $elem = elem instanceof jQuery ? elem : $(elem);

    $(() => {
      // Send initial height then wait for changes

      // Keep polling the height until it is loaded
      const t = setInterval(() => {
        let lastHeight = DOMUtils.getContentHeight($elem);
        if (lastHeight === 0) {
          return;
        }

        clearInterval(t);

        callback(lastHeight);

        const observer = new MutationObserver(() => {
          // Callback with the new height when it changes
          const height = DOMUtils.getContentHeight($elem);
          if (height !== lastHeight) {
            callback(height);
            lastHeight = height;
          }
        });

        // Which mutations to observe
        const config = { attributes: true, childList: true, subtree: true };

        // Start observing the element
        observer.observe($elem[0], config);
      }, 1);
    });
  }

  static getStylesheetElem(hrefIncludes = "") {
    const $elems = $("head link[rel='stylesheet']");
    return $elems.filter((index, elem) => {
      const href = $(elem).attr("href");
      return href.includes(hrefIncludes);
    })
  }
}
